// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"be3141c8","763":"0b03fb58"}[chunkId] + ".chunk.js";
};